module.exports = "<div class=\"divider-group divider-group-box\"> <div class=row> <div class=col-xs-3> </div> <div class=col-xs-3> <div class=\"q-marg-vert-xxs q-boldest\"> <i class=\"fa fa-level-down q-icon-lg q-icon-marg-right\" aria-hidden=true></i> {%- productSku %} </div> </div> <div class=col-xs-4> <div class=\"q-marg-vert-xxs q-break-word\"> {%- prodDesc %} </div> </div> <div class=col-xs-2> {%= productUnitsAvail %} </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/html/bundleChildBodyOnReviewTab.html
// module id = 1356
// module chunks = 1